import { SalesOrderStatus, type SalesOrderListItemDto } from '../types/salesOrder.types';
import type { FilterTab } from '../store/salesOrderWorkspaceStore';

// 86d3bujyr / 86d3mnuxe — single source of truth for master-list filter membership. drafts = the
// in-progress set; a posting-in-flight or posting-failed SO is now a Draft entity (the posting lifecycle
// lives on the outbox), so it stays in this tab and shows its "Posting…"/"Failed" badge from the outbox
// status. submitted = posted; archived = IsArchived.

export const DRAFT_STATUSES = [SalesOrderStatus.Draft];

/** The status set to query for a tab, or undefined for `archived` (which uses includeArchived). */
export function statusesForFilter(tab: FilterTab): SalesOrderStatus[] | undefined {
  if (tab === 'drafts') return DRAFT_STATUSES;
  if (tab === 'submitted') return [SalesOrderStatus.Submitted];
  return undefined;
}

/** Whether a (possibly just-updated) row still belongs in the active tab. */
export function rowMatchesFilter(row: SalesOrderListItemDto, tab: FilterTab): boolean {
  if (tab === 'archived') return row.isArchived;
  if (row.isArchived) return false; // archived rows never belong on drafts/submitted
  return statusesForFilter(tab)?.includes(row.status) ?? true;
}
